import React, {FC, useEffect, useState} from "react";
import ProfileHeader from "../Headers/ProfileHeader";
import {
  validateWalletSignature,
  delLinkedApp,
  getConfig,
  getLinkedApps,
  postConfig,
  postLinkedApp
} from "../../lib/api";
import pkceChallenge from 'pkce-challenge';
import {Button, FormLabel, Modal} from "react-bootstrap";
import {EditableText} from "../Shared/EditableWidgets";
import Web3 from "web3";

declare let window: any;
let web3: Web3 | undefined = undefined; // Will hold the web3 instance

function isAddress(walletAddress: string) {
  return walletAddress.match(/^0x[a-fA-F0-9]{40}$/);
}

interface ModalNoWalletProps {
  show: boolean,
  setShow: any
}

const ModalNoWallet: FC<ModalNoWalletProps> = ({show, setShow}) => {
  return (
    <Modal className="modal-signup" show={show} size="lg"
           aria-labelledby="contained-modal-title-vcenter"
           centered
    >
      <Modal.Header closeButton onClick={() => setShow(false)}>
        <Modal.Title>
          <h4 className="text-center">No wallet detected</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col py-2">
            <h6>
              We could not find a wallet. Please install an Ethereum wallet such as <a href="https://metamask.io/"><span
              className="orange">MetaMask</span></a>. If you're having issues with an installed wallet please <a
              href="mailto:info@villa.rocks"><span className="orange">contact us</span></a>.
            </h6>
          </div>
        </div>
        <div className="row">
          <div className="col text-center py-4">
            <Button
              size="lg"
              onClick={() => setShow(false)}
              variant="primary"
            >
              Ok
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}


function postWalletAddress(name: string, address: string, isConnected: boolean, refresh: any) {
  postLinkedApp({
    name: name,
    code: address,
    appType: 'wallet',
    blockchain: 'ETH',
    isConnected: isConnected
  }).then((response) => {
    refresh();
    if (!response.ok) {
      response.json().then(json => {
        console.error(json?.error); // TODO: show in UI
      });
    }
  })
}

interface AddViewOnlyWalletProps {
  showViewOnlyFields: boolean,
  setShowViewOnlyFields: any,
  refresh: any
}

const AddViewOnlyWallet: FC<AddViewOnlyWalletProps> = ({showViewOnlyFields, setShowViewOnlyFields, refresh}) => {
  const [name, setName] = useState('');
  const [walletAddress, setWalletAddress] = useState('');
  const [nameError, setNameError] = useState('');
  const [addressError, setAddressError] = useState('');

  function validateAddress(address: string) {
    if (isAddress(address)) {
      setAddressError('');
      return true;
    }

    setAddressError('This does not appear to be a valid Ethereum wallet address');
    return false;
  }

  function validateName(name: string) {
    if (name.length > 0) {
      setNameError('');
      return true;
    }

    setNameError('Please enter a longer name');
    return false;
  }

  function cancel() {
    setShowViewOnlyFields(false);
    // setName(org.name);
    // setDescription(org.description);
    // setError(null);
    // setIsEditing(false);
    // if (orgId === 'new') {
    //   setRedirectToPath('/home');
    // }
  }

  function save() {
    if (!(validateAddress(walletAddress) && validateName(name))) {
      return;
    }
    postWalletAddress(name, walletAddress, false, refresh);
  }

  function setNameAndValidate(name: any) {
    setName(name);
    validateName(name);
  }

  function setAddressAndValidate(address: any) {
    setWalletAddress(address);
    validateAddress(address);
  }

  const nameErrorMessage =
    nameError.length > 0 ?
      <div className="row pb-3 error">
        <div className="col-12 offset-md-2">
          {nameError}
        </div>
      </div>
      : null;

  const addressErrorMessage =
    addressError.length > 0 ?
      <div className="row pb-3 error">
        <div className="col-12 offset-md-2">
          {addressError}
        </div>
      </div>
      : null;


  if (showViewOnlyFields) {
    return (
      <div className="row">
        <div className="col">
          <div className="row px-3 py-0 d-md-none">
            <div className="col-md-12 px-0 py-0">
              <FormLabel className="mb-0 h-auto">Name</FormLabel>
            </div>
          </div>
          <div className="row px-3 py-2">
            <div className="d-none d-md-block col-md-2 text-right">
              <FormLabel>Name</FormLabel>
            </div>
            <div className="col-12 col-md-4 px-0">
              <div className="row">
                <div className="col">
                  <EditableText
                    value={name}
                    maxLength={60}
                    onChange={(event: any) => setNameAndValidate(event.target.value)}
                    isEditable={true}
                    isEditing={true}
                    setIsEditing={() => {
                    }}
                    placeholder="Name of wallet"
                    ariaLabel="Name of wallet"
                  />
                </div>
              </div>
            </div>
          </div>
          {nameErrorMessage}
          <div className="row px-3 py-0 d-md-none">
            <div className="col-md-12 px-0 py-0">
              <FormLabel className="mb-0 h-auto">Wallet&nbsp;Address</FormLabel>
            </div>
          </div>
          <div className="row px-3 py-2">
            <div className="d-none d-md-block col-md-2 text-right">
              <FormLabel>Address</FormLabel>
            </div>
            <div className="col-12 col-md-4 px-0">
              <div className="row">
                <div className="col">
                  <EditableText
                    value={walletAddress}
                    maxLength={42}
                    onChange={(event: any) => setAddressAndValidate(event.target.value)}
                    isEditable={true}
                    isEditing={true}
                    setIsEditing={() => {
                    }}
                    placeholder="Wallet address"
                    ariaLabel="Wallet address"
                  />
                </div>
              </div>
            </div>
          </div>
          {addressErrorMessage}
          <div className="row px-3 py-2">
            <div className="d-none d-md-block col-md-2 text-right">
              &nbsp;
            </div>
            <div className="col-12 col-md-4 px-0">
              <Button
                className="ml-2"
                onClick={cancel}
                variant="secondary">
                Cancel
              </Button>
              <Button
                className="ml-2"
                onClick={save}
                variant="primary">
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="row pb-4">
      <div className="col">
        <Button
          onClick={() => setShowViewOnlyFields(true)}
          variant="primary"
        >Add</Button>
        <span className="ml-2">Add any other wallet addresses to view their NFTs in Villa</span>
      </div>
    </div>
  )
}


function ShowSampleWallets(props: { config: any, refresh: any }) {
  const {config, refresh} = props;
  const showSampleWallets = !!config?.sampleWallets?.show;

  function updateShowSampleWallets() {
    postConfig({sampleWallets: {show: !showSampleWallets}}).then(response => {
      refresh();
    });
  }

  return (
    <>
      <h5 className="pt-1 pb-1">Featured wallets that will change from time to time</h5>
      <div className="row">
        <div className="col-12">
          <input id="showSampleWallets" type="checkbox" checked={showSampleWallets} onClick={updateShowSampleWallets}/>
          <label htmlFor="showSampleWallets">&nbsp;Show featured wallets in VR</label>
        </div>
      </div>
    </>
  );
}

function AppIntegrations(props: { cognitoUser: any }) {
  const {cognitoUser} = props;
  const [linkedApps, setLinkedApps] = useState<any>([]);
  const [config, setConfig] = useState<any>({});
  const [showAddViewOnlyFields, setShowAddViewOnlyFields] = useState(false);
  const [error, setError] = useState(null);
  const [zoomUrl, setZoomUrl] = useState('');

  useEffect(() => {
    refreshLinkedApps();
    // DEBUG
    // sketchfabMe().then(response => {
    //    if (response.ok) {
    //      response.json().then(json => {
    //        console.log(json);
    //     });
    //   } else {
    //      console.error(response);
    //    }
    //  });
  }, []);

  function refreshLinkedApps() {
    setError(null);
    setShowAddViewOnlyFields(false);
    getLinkedApps().then(response => {
      if (response.ok) {
        response.json().then(json => {
          setLinkedApps(json["linkedApps"]);
          const zoomApp = json["linkedApps"].find((app: any) => app.name === 'Zoom');
          if (zoomApp) {
            setZoomUrl(zoomApp.metadata.url || '');
          }
        });
      }
    });
    getConfig().then(response => {
      if (response.ok) {
        response.json().then(json => setConfig(json))
      }
    });
  }

  function LinkedApp(props: { app: any, unlink: (app: any) => void, refresh: any }) {
    const {app, unlink, refresh} = props;
    const [showNoWallet, setShowNoWallet] = useState(false);
    const [zoomMessage, setZoomMessage] = useState('');

    const handleAuthenticate = ({
                                  publicAddress,
                                  signature,
                                  message,
                                }: {
      publicAddress: string;
      signature: string;
      message: string;
    }) => {
      return validateWalletSignature({id: app.id, publicAddress, signature}).then(response => {
          if (response.ok) {
            return ({publicAddress, signature, message});
          } else {
            throw new Error('Invalid signature');
          }
        }
      )
    }

    const handleSignMessage = async ({
                                       publicAddress,
                                       message,
                                     }: {
      publicAddress: string;
      message: string;
    }) => {
      try {
        const signature = await web3!.eth.personal.sign(
          message,
          publicAddress,
          '' // MetaMask will ignore the password argument here
        );

        return {publicAddress, signature, message};
      } catch (err) {
        throw new Error(
          'You need to sign the message to be able to log in.'
        );
      }
    };

    const handleSignup = (publicAddress: string) =>
      fetch(`${process.env.REACT_APP_BACKEND_URL}/users`, {
        body: JSON.stringify({publicAddress}),
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
      }).then((response) => response.json());


    const saveWallet = async ({publicAddress}: { publicAddress: string }) => postWalletAddress("Ethereum Wallet", publicAddress, true, refresh);

    const handleClick = async () => {
      // Check if MetaMask is installed
      if (!(window as any).ethereum) {
        window.alert('Please install MetaMask first.');
        return;
      }

      if (!web3) {
        try {
          // Request account access if needed
          await window.ethereum.request({method: 'eth_requestAccounts'})

          // We don't know window.web3 version, so we use our own instance of Web3
          // with the injected provider given by MetaMask
          web3 = new Web3((window as any).ethereum);
        } catch (error) {
          window.alert('You need to allow MetaMask.');
          return;
        }
      }

      const publicAddress = await web3.eth.getCoinbase();
      if (!publicAddress) {
        window.alert('Please activate MetaMask first.');
        return;
      }

      // setLoading(true);
      const message = `I am signing to link my wallet: ${app.nonce}`;
      handleSignMessage({publicAddress, message})
        // Send signature to backend on the /auth route
        .then(handleAuthenticate)
        // Pass accessToken back to parent component (to save it in localStorage)
        .then(saveWallet)
        .catch((err) => {
          window.alert(err);
          // setLoading(false);
        });
    };

    function linkWallet() {
      handleClick().then(response => {
      });
    }

    function inputZoomUrl(app: any) {
      if (app.name !== 'Zoom') {
        return null
      }
      let source = '';
      if (zoomUrl.length > 0) {
        if (app.metadata.source === 'unreal') {
          source = "Zoom Meeting Generated from VR";
        } else if (app.metadata.source == 'external') {
          source = "External Zoom Meeting Link"
        }
      }

      return (
        <>
          <div className="row">
            <div className="col-12">
              {source}
            </div>
          </div>
          <div className="row pb-4">
            <div className="col-3">
              <input value={zoomUrl} className="w-100" placeholder="Copy/paste Zoom URL"
                     onChange={(event: any) => setZoomUrl(event.target.value)}/>
            </div>
            <div className="col-9">
              <button onClick={saveZoomUrl}>Save Zoom URL</button>
              <button className="ml-3" onClick={copyZoomUrl}>Copy Zoom URL</button>
              <span className="ml-2">{zoomMessage}</span>
            </div>
          </div>
        </>
      )
    }

    function copyZoomUrl() {
      navigator.clipboard.writeText(zoomUrl).then(() => {
          setZoomMessage('Copied to clipboard!');
          setTimeout(() => setZoomMessage(''), 1000);
        }
      );
    }

    function saveZoomUrl() {
      setZoomMessage('Saving...');
      postLinkedApp({name: 'Zoom', metadata: {url: zoomUrl}}).then(response => {
          setZoomMessage('Saved!');
          setTimeout(() => {
            setZoomMessage('');
            refresh();
          }, 1000);
        }
      );
    }


    function getAction(app: any, unlink: (app: any) => void) {
      if (app.isLinked) {
        if (app.sample) {
          return `Sample ${app.appType}`;
        }
        return (
          <a href="/#" className="btn btn-primary" onClick={(e) => {
            unlink(app);
            e.preventDefault();
          }}>Disconnect</a>
        );
      }

      if (app.appType === "wallet") {
        return (
          <a href="/wallet" className="btn btn-primary" onClick={(e) => {
            linkWallet();
            e.preventDefault();
          }}>Connect</a>
        );
      } else {
        let oauthPath = app.oauthPath;
        if (/&code_challenge=&/.test(app.oauthPath)) {
          const {code_verifier, code_challenge} = pkceChallenge();
          oauthPath = oauthPath.replace('&code_challenge=&', `&code_challenge=${code_challenge}&`)
          localStorage.code_verifier = code_verifier;
        }
        return (<a href={oauthPath} className="btn btn-primary">Connect</a>);
      }
    }

    const action = getAction(app, unlink);
    const walletAddress = app.appType === "wallet" && app.code ?
      <div className="row col pb-4">
        <span className="rounded bg-secondary p-1">{app.code}</span>
      </div>
      : null;
    const imgClass = (app.name === 'Epidemic Sound' || app.name === 'Zoom') ? 'ml-2 mr-3' : ''
    const imgWidth = (app.name === 'Epidemic Sound' || app.name === 'Zoom') ? '25' : '50';
    return (
      <>
        <ModalNoWallet show={showNoWallet} setShow={setShowNoWallet}/>
        <div className="row align-items-baseline">
          <div className="col-3 text-left">
            {action}
          </div>
          <div className="col-9 text-nowrap">
            <img src={app.image} alt={app.name} width={imgWidth} className={imgClass}/>
            {app.name}
          </div>
        </div>
        {walletAddress}
        <div className="row pb-4">
          <div className="col">
            {app.description}
          </div>
        </div>
        {inputZoomUrl(app)}
      </>
    );
  }

  function unlink(app: any) {
    delLinkedApp(app.id).then(response => {
      if (response.ok) {
        refreshLinkedApps();
        return;
      } else {
        response.json().then(json => {
          setError(json?.error);
        })
      }
    });
  }

  const apps = linkedApps.filter((app: any) => app.appType != "wallet");
  const userWallets = linkedApps.filter((app: any) => app.appType === "wallet" && !app.sample);
  const sampleWallets = linkedApps.filter((app: any) => app.appType === "wallet" && !!app.sample);
  const appComponents = apps.map((app: any) => {
      return <LinkedApp app={app} key={`app-${app.name}`} unlink={unlink} refresh={refreshLinkedApps}/>
    }
  );
  const userWalletComponents = userWallets.map((app: any) => {
      return <LinkedApp app={app} key={`app-${app.name}`} unlink={unlink} refresh={refreshLinkedApps}/>
    }
  );
  const sampleWalletComponents = sampleWallets.map((app: any) => {
      return <LinkedApp app={app} key={`app-${app.name}`} unlink={unlink} refresh={refreshLinkedApps}/>
    }
  );

  return (
    <>
      <ProfileHeader cognitoUser={cognitoUser} title="App Integrations" linkToHome="/"/>
      <section className="container main p-4 rounded">
        {error ?
          (
            <div className="row error">
              <div className="col-12">
                {(error as any)?.message}
              </div>
            </div>
          )
          : null
        }
        <h4>Apps</h4>
        <div className="row pb-3">
          <div className="col pt-2 border-section">
            {appComponents}
          </div>
        </div>
        <h4>My Ethereum wallets</h4>
        <div className="row pb-3">
          <div className="col border-section">
            {userWalletComponents}
            <AddViewOnlyWallet showViewOnlyFields={showAddViewOnlyFields}
                               setShowViewOnlyFields={setShowAddViewOnlyFields}
                               refresh={refreshLinkedApps}/>
          </div>
        </div>
        <h4>Sample Ethereum wallets</h4>
        <div className="row pb-3">
          <div className="col border-section">
            <ShowSampleWallets config={config} refresh={refreshLinkedApps}/>
            {sampleWalletComponents}
          </div>
        </div>
      </section>
    </>
  );
}

export default AppIntegrations;
